export const MODULE_NAME = 'productPicker';
